<template>
  <div class="cross-project-project-item" :class="{'locked': !hasPermission}" @click="viewProject($event)">
    <ColorCard :dataset="projectInfo" :locked="!hasPermission" @change="colorChange" :disabled="!projectInfo.permissions" :defaultText="projectInfo.title">
      <template>
        <div class="cross-project-content" v-if="hasPermission">
          <ToolTip maxWidth="180px" :title="projectInfo.title">{{ projectInfo.title }}</ToolTip>
          <div class="tool-box">
            <el-dropdown placement="bottom" v-if="joinOrRemoveSubproject" @command="handleCommand" trigger="click" @visible-change="delVisibleChange">
              <span class="el-dropdown-link showOr" @click.stop>
                <i class="icon iconfont iconicon_user_more_task tableIconHover" :class="{'visibleActive': delVisible}"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="project-item-more-dropdown">
                <el-dropdown-item>
                  <i class="icon iconfont iconicon_delete"></i>
                  移除子项目
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <i class="icon iconfont iconicon_following follow" v-if="projectInfo.project_mark_star && projectInfo.project_mark_star.is_mark"></i>
          </div>
        </div>
        <div class="cross-project-content" v-else>
          <div class="project-top-wrap">
            <ToolTip :maxWidth="'150px'" :title="projectInfo.title">{{ projectInfo.title }}</ToolTip>
            <el-tooltip
              v-if="projectInfo.content"
              class="project-item-desc"
              effect="dark"
              :content="projectInfo.content"
              placement="bottom"
            >
              <i class="icon iconfont iconicon_help_nor"></i>
            </el-tooltip>
          </div>
          <el-dropdown
            v-if="managersList.length"
            class="project-check-managers"
            trigger="click"
            :placement="'bottom-start'"
            @visible-change="handleDropdownChange"
          >
            <span class="el-dropdown-link" @click.stop>
              <el-tooltip
              class="project-item-desc"
              effect="dark"
              content="查看管理员"
              placement="bottom"
              :disabled="adminVisible"
            >
              <i ref="arrowIcon" class="icon iconfont iconicon_administrators tableIconHover" :class="{'visibleActive': adminVisible}"></i>
              </el-tooltip>
            </span>
            <el-dropdown-menu slot="dropdown" class="subproject-managers-list">
              <el-dropdown-item v-for="item of managersList" :key="item.uid">
                <Myavatar
                  width="28px"
                  height="28px"
                  fontSize="12px"
                  :imgUrl="item.user_avatar"
                  :userName="item.realname"
                  :showToolTip="false"
                ></Myavatar>
                  <span>{{ item.realname }}</span>
                </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <p v-else class="nobody">暂无管理员</p>
        </div>
      </template>
    </ColorCard>
    <div class="task-msgcount-super" v-show="projectInfo.msgcount > 0">{{projectInfo.msgcount > 100 ? '99+' : projectInfo.msgcount}}</div>
  </div>
</template>

<script>
import ToolTip from '@/components/toolTip'
//api
import api from '@/services/api/home/home'
import apiProject from '@/services/api/project/project'
import ColorCard from '@/components/colorControl/card'
export default {
  name: "ProjctItem",
  components: {
    ToolTip,
    ColorCard
  },
  props: {
    projectInfo: {
      type: Object
    },
    joinOrRemoveSubproject: { // 增/删子项目权限
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasPermission() {
      //是否有查看子项目的权限
      //获取用户uid，判断是否在该子项目的成员里面
      const _uid = JSON.parse(localStorage.getItem('wfUserInfo')).uid
      let _bol = false
      this.projectInfo.member.find((item) => {
        if (item.uid === _uid) {
          _bol = true
        }
      })
      return _bol
    },
    managersList() {
      //管理员列表
      return !this.hasPermission ? this.projectInfo.member.filter(item => { return item.type !== 0 }) : []
    }
  },
  data() {
    return {
      editVisible: false,
      delVisible: false,
      adminVisible: false
    }
  },
  methods: {
    close() {
      this.editVisible = false
    },
    viewProject($event) {
      // let e = $event.target
      // const classArr = ['el-dropdown', 'project-item-has-permission']
      // while (classArr.indexOf(e.className) < 0) {
      //   e = e.parentNode
      // }
      // if (e.className == 'el-dropdown') return
      if(!this.hasPermission) return
      this.$router.push({
        path: "/task",
        query: {
          projectId: this.projectInfo.project_id,
          isTabShow: true
        }
      })
    },
    handleCommand() {
      const param = {
        cross_project_id: 0,
        project_ids: [this.projectInfo.project_id]
      }
      this.$wfAlert('', '确定移除此项目吗？', '', '确定').then(async () => {
        const res = await api.addDelSubproject(param)
        if (res) {
          this.$message({
            message: '移除成功',
            type: 'success'
          })
          this.$emit('update')
        }
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    },
    //根据下拉菜单是否弹出来变换让箭头icon翻转
    handleDropdownChange(val) {
      this.adminVisible = val
    },
    async colorChange(val) {
      let { project_id, background_color, background_text} = val
      this.projectInfo.background_color = background_color
      this.projectInfo.background_text= background_text
      let params = {
        project_id,
        background_color,
        background_text
      }
      await apiProject.updateProjectBackground(params)
    },
    delVisibleChange(val) {
      this.delVisible = val
    }
  }
}
</script>

<style lang="scss" scoped>
.cross-project-project-item {
  position: relative;
  width: 280px;
  margin-bottom: 16px;
  margin-right: 16px;
  border-radius: 8px;
  .cross-project-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    font-size: 14px;
    i {
      color: rgba(32, 32, 32, 0.6);
      margin-left: 8px;
    }
    .showOr {
      visibility: hidden;
    }
    .follow {
      color: rgba(255, 190, 35, 0.8);
      font-weight: 400;
    }
    .tool-box {
      flex-shrink: 0;
    }
    .project-top-wrap {
      display: flex;
      align-items: center;
    }
    .nobody {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      visibility: hidden;
    }
    .project-check-managers {
      visibility: hidden;
    }
  }
  &:hover {
    .cross-project-content .showOr {
      visibility: visible;
    }
    .project-check-managers {
      visibility: visible;
    }
    .nobody {
      visibility: visible;
    }
  }
  &.locked {

  }
}
.project-item-more-dropdown {
  .el-dropdown-menu__item {
    color: #FF3939;
    i {
      color: #FF3939;
    }
    &:hover,
    &:active {
      i {
        color: #FF3939 !important;
      }
      color: #FF3939 !important;
    }
  }
}

.subproject-managers-list {
  width: 124px;
  .el-dropdown-menu__item {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    span {
      margin-left: 8px;
    }
  }
}
</style>
